import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { CoinComponent } from '../Gamification/CoinComponent'
import Amplitude from 'src/utils/amplitudeHelper'

const StyledModal = styled(Modal)`
  color: #505c7c;
  .modal-content {
    padding: 0 8px;
    border: none;
    border-radius: 20px;
  }
  .modal-header {
    border: none;
  }
  .close {
    border: none;
    font-size: 24px;
    background: transparent;
  }
  .file-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    p {
      word-break: break-all;
    }
    button {
      background: transparent;
      border: none;
      color: #FFAD2C;
    }
  }
`
export const gileadVideos = [
  {
    filename: "Kite State of the Art Manufacturing Process",
    link: "https://vimeo.com/653082463"
  }
]
export const abbvieVideos = [
  {
    filename: 'Video 1',
    link: 'https://players.brightcove.net/1029485116001/default_default/index.html?videoId=6305924298112'
  },
  {
    filename: 'Video 2',
    link: 'https://players.brightcove.net/1029485116001/default_default/index.html?videoId=6301427978001'
  },
  {
    filename: 'Video 3',
    link: 'https://players.brightcove.net/1029485116001/default_default/index.html?videoId=6309228734112'
  },
]
export default function CustomVideoModal({ boothId, customOpen, setCustomOpen }) {
  const { boothMissions } = useSelector((state) => state.booth)
  const [mission, setMission] = useState({})

  const videos = boothId === 7 ? gileadVideos : abbvieVideos
  
  useEffect(() => {
    setMission(boothMissions.find(ms => ms.mission_type === "watch_video"))
  }, [boothMissions])

  const openNewTab = (vid) => {
    Amplitude.openCustomVideo(vid.filename)
    window.open(vid.link, "_blank")
  }
  return (
    <StyledModal
      show={customOpen}
      onHide={()=>setCustomOpen(false)}
      aria-labelledby="video-modal"
      centered
    >
      <Modal.Header closeButton>
        <h6 id="video-modal">Select video(s) to play</h6>
      </Modal.Header>
      {mission && <CoinComponent mission={mission} />}
      <Modal.Body>
        <h6></h6>
        {
          videos.map((video,index)=>(
            <div key={`video-${index}`} className="file-container">
              <p>{video.filename}</p>
              <button onClick={()=>openNewTab(video)}>
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#F83636" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <polygon points="10 8 16 12 10 16 10 8"></polygon>
                </svg>
              </button>
            </div>
          ))
        }
      </Modal.Body>
    </StyledModal>
  )
}
